const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as string | undefined;

export function PaymentTestModeBanner() {
  if (!clientToken?.startsWith("pk_test_")) return null;
  return (
    <div className="w-full bg-orange-100 border-b border-orange-300 pl-28 pr-4 sm:px-4 py-2 text-center text-xs text-orange-800">
      Pagos en modo de prueba. Usa la tarjeta <strong>4242 4242 4242 4242</strong>, cualquier fecha futura y CVC.
    </div>
  );
}
